import { render, staticRenderFns } from "./SysCategoryModal.vue?vue&type=template&id=0606d3e0"
import script from "./SysCategoryModal.vue?vue&type=script&lang=js"
export * from "./SysCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0606d3e0')) {
      api.createRecord('0606d3e0', component.options)
    } else {
      api.reload('0606d3e0', component.options)
    }
    module.hot.accept("./SysCategoryModal.vue?vue&type=template&id=0606d3e0", function () {
      api.rerender('0606d3e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/SysCategoryModal.vue"
export default component.exports